import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';

const useOneReaderSyllabusStyles = makeStyles({
  uploadedFileIcon: {
    fontSize: 48,
    color: '#fff'
  },
  uploadIcon: {
    fontSize: 48,
    color: '#fff'
  },
  fileError: {
    color: mixins.swatchDanger,
    marginTop: 12
  },
  uploadedFileName: {
    marginBottom: 4,
    wordBreak: 'break-all'
  },
  uploadBoxActive: {
    borderColor: '#ffd966',
    background: 'rgba(255,217,102,0.08)'
  },
  header: {
    marginBottom: 16,
    color: mixins.chalkWhiteFont
  },
  back: {
    cursor: 'pointer',
    color: mixins.chalkWhiteFont
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    flex: '1 0 0',
    padding: 20
  },
  iconBox: {
    borderRadius: '50%',
    width: 80,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    boxSizing: 'border-box'
  },
  progressDeterminate: {
    backgroundColor: '#E0E0E0', // Background color for remaining portion
    '& .MuiLinearProgress-bar': {
      backgroundColor: mixins.amethyst // Color for uploaded portion
    }
  },
  progressBar: {
    backgroundColor: mixins.amethyst // Color for uploaded portion
  },
  progressRoot: {
    flexGrow: 1,
    height: 4,
    borderRadius: 4,
    marginRight: 12,
    width: '100%'
  },
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: 24
  },
  progressText: {
    color: mixins.blackColor
  },
  progressTextItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: 'calc((100% - 320px)/ 2)',
    marginBottom: 8,
    minWidth: 300,
    position: 'relative',
    paddingLeft: 26 // Reserve space for tick icon (18px + 8px margin)
  },
  deleteIcon: {
    color: mixins.navyColor
  },
  deleteIconContainer: {
    position: 'relative',
    top: '-128px',
    left: '50%'
  },
  progressTextsContainer: {
    marginBottom: 16,
    minHeight: 120,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    width: '100%'
  },
  checkIcon: {
    color: mixins.accentGreen,
    fontSize: 18,
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  percent: {
    marginBottom: 0,
    minWidth: 40,
    textAlign: 'right',
    alignSelf: 'end',
    display: 'flex'
  },
  title: {
    marginBottom: 12
  },
  desc: {
    marginBottom: 32
  },
  uploadBox: {
    border: `2px dashed ${mixins.amethyst}`,
    borderRadius: 16,
    maxWidth: 768,
    padding: '64px 32px',
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    justifyContent: 'center',
    minHeight: 263
  },
  uploadDragText: {
    color: mixins.color_text_primary,
    fontSize: 20,
    fontWeight: 500
  },
  uploadDragContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 8
  },
  uploadDragIcon: {
    fontSize: 28,
    color: mixins.color_text_primary,
    verticalAlign: 'middle'
  },
  root: {
    width: '100%',
    backgroundColor: mixins.chalkWhiteFont,
    padding: 16,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 12,
    alignSelf: 'stretch',
    gap: 16,
    height: '100vh'
  },
  contentWrapper: {
    width: '100%',
    flex: 1,
    minHeight: 0
  },
  tabsContainer: {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    minHeight: 0,
    '& .MuiTabs-indicator': {
      backgroundColor: mixins.purpleSelectedTabUnderline,
      height: 4,
      borderRadius: 4
    }
  },
  tab: {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '18px',
    minHeight: 40,
    padding: '0 24px',
    color: mixins.swatchDarkFont,
    '&.Mui-selected': {
      fontWeight: 500
    }
  },
  tabPanel: {
    width: '100%',
    flexGrow: 1
  },
  ctaSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    width: '100%'
  },
  uploadButton: {
    backgroundColor: mixins.amethyst,
    color: 'white',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'none',
    borderRadius: 8,
    '&:hover': {
      background: mixins.amethyst
    }
  },
  footerText: {
    color: mixins.mutedTextColor,
    fontSize: '14px',
    textAlign: 'center'
  }
});

export default useOneReaderSyllabusStyles;
